export default __webpack_public_path__ + "static/media/KOD0092-min.fc78d1b2.webp";